import React from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import { useTreatmentContext } from '../../../../../Services/TreatmentContext';
import ElectronicPrescriptionDetail from './ElectronicPrescriptionDetail';
import { NCZIElectronicPrescriptionItem } from '../../../Interfaces/ncziElectronicPrescriptionItem';
import useTranslation from '../../../../../Hooks/useTranslation';
import { Size } from '../../../../../Enums/Size.enum';

interface Props {
	opened: boolean;
	onClose: (needReload: boolean) => void;
	item: NCZIElectronicPrescriptionItem;
}

const ElectronicPrescriptionDetailModal: React.FC<Props> = props => {
	const { opened, onClose, item } = props;
	const { t } = useTranslation();
	const { isCase } = useTreatmentContext();

	return (
		<Modal
			opened={opened}
			onClose={() => onClose(false)}
			fullScreen={false}
			wrapChat={isCase}
			size={Size.MD}>
			<Modal.Header
				title={
					t('nczi.electronicPrescription.detail.title') + ' ' + item.CiarovyKod
				}
			/>
			<Modal.Content>
				<ElectronicPrescriptionDetail onClose={onClose} item={item} />
			</Modal.Content>
		</Modal>
	);
};

export default ElectronicPrescriptionDetailModal;
